/*
 * Copyright 2026 Mifos Initiative
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/openMF/kmp-project-template/blob/main/LICENSE
 */
package kpt.core.base.ui

/**
 * The SINGLE common-code accessor for the app's user-facing display name.
 *
 * DERIVED from app-profile/app.yaml#identity.app_name via syncForkConfig
 *   → gradle/fork.properties#app.display.name
 *   → BuildKonfig field APP_DISPLAY_NAME (module-local, generated by the BuildKonfig plugin).
 *
 * Every UI surface that renders the app's title/name MUST read this — NEVER hardcode a brand-literal
 * string such as an app name in a composable or strings.xml (RULE-IMPL-NO-HARDCODED-STRING-001). A
 * fork rebrands in app-profile only; the display name flows here automatically.
 */
object AppInfo {
    /**
     * The fork's display name, from `app-profile` via BuildKonfig — never hardcoded, so a rebrand needs no code
     * change.
     */
    val appDisplayName: String get() = BuildKonfig.APP_DISPLAY_NAME
}
